import { create } from "zustand";

/**
 * Store for managing drag state across the 3D viewer.
 * Tracks which part is being dragged and provides centralized state management.
 */
interface DragState {
  /** The ID of the part currently being dragged, or null if no drag is active */
  draggingPartId: string | null;
  /** Whether a drag operation is currently active (used to suppress click events) */
  isDragActive: boolean;

  /** Start dragging a specific part */
  startDrag: (partId: string) => void;
  /** End the current drag operation */
  endDrag: () => void;
}

export const useDragStore = create<DragState>((set) => ({
  draggingPartId: null,
  isDragActive: false,

  startDrag: (partId: string) => {
    set({ draggingPartId: partId, isDragActive: true });
  },

  endDrag: () => {
    // Small delay before clearing drag state to allow click suppression
    setTimeout(() => {
      set({ draggingPartId: null, isDragActive: false });
    }, 100);
  },
}));
